
    (function () {
        const viewport = document.getElementById('svastiCarouselViewport');
        const prevBtn = document.getElementById('svastiPrev');
        const nextBtn = document.getElementById('svastiNext');
        const CARD_WIDTH = 286;
        // 1. Navigation Buttons
        if (prevBtn) prevBtn.addEventListener('click', () => {
            viewport.scrollBy({ left: -284, behavior: 'smooth' });
            stopAutoScroll();
            setTimeout(startAutoScroll, 3000);
        });
        if (nextBtn) nextBtn.addEventListener('click', () => {
            viewport.scrollBy({ left: 284, behavior: 'smooth' });
            stopAutoScroll();
            setTimeout(startAutoScroll, 3000);
        });
        // 2. Auto Scroll Logic (Faster Interval)
        let autoScrollInterval;
        function startAutoScroll() {
            stopAutoScroll();
            autoScrollInterval = setInterval(() => {
                // Check if near end
                if (viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 10) {
                    viewport.scrollTo({ left: 0, behavior: 'auto' }); // Instant jump back to start loop
                } else {
                    viewport.scrollBy({ left: 284, behavior: 'smooth' });
                }
            }, 2000); // 2000ms = Faster Speed
        }
        function stopAutoScroll() {
            if (autoScrollInterval) clearInterval(autoScrollInterval);
        }
        // Start on Load
        startAutoScroll();
        // Pause on Interaction
        viewport.addEventListener('touchstart', stopAutoScroll, { passive: true });
        viewport.addEventListener('mousedown', stopAutoScroll);
        // Resume after leave
        viewport.addEventListener('touchend', () => setTimeout(startAutoScroll, 2000));
        viewport.addEventListener('mouseleave', () => setTimeout(startAutoScroll, 2000));
    })();
